/* Derma Pura collection page: sidebar groups, filter drawer (≤1024px), sort dropdown, SHOW MORE */
(function () {
  function init(root) {
    if (root.dataset.dpclReady) return;
    root.dataset.dpclReady = '1';

    root.querySelectorAll('[data-dpcl-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var block = btn.closest('.dpcl__sb-block');
        var open = block.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });

    function setDrawer(open) {
      root.classList.toggle('is-filter-open', open);
      document.body.classList.toggle('dpcl-lock', open);
    }
    root.querySelectorAll('[data-dpcl-open]').forEach(function (b) {
      b.addEventListener('click', function () { setDrawer(true); });
    });
    root.querySelectorAll('[data-dpcl-close]').forEach(function (b) {
      b.addEventListener('click', function () { setDrawer(false); });
    });

    var sort = root.querySelector('[data-dpcl-sort]');
    if (sort) {
      var toggle = sort.querySelector('[data-dpcl-sort-toggle]');
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sort.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
      });
      document.addEventListener('click', function (e) {
        if (!sort.contains(e.target)) {
          sort.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      setDrawer(false);
      if (sort) sort.classList.remove('is-open');
    });

    var more = root.querySelector('[data-dpcl-more]');
    var grid = root.querySelector('[data-dpcl-grid]');
    if (more && grid) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        if (more.classList.contains('is-loading')) return;
        more.classList.add('is-loading');
        fetch(more.getAttribute('href'), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.getElementById(root.id);
            if (!next) throw new Error('section not found');
            next.querySelectorAll('[data-dpcl-grid] > .dpcl__item').forEach(function (li) {
              grid.appendChild(document.importNode(li, true));
            });
            var total = parseInt(more.dataset.total, 10) || 0;
            var shown = grid.children.length;
            var end = root.querySelector('[data-dpcl-end]');
            var bar = root.querySelector('[data-dpcl-progress]');
            if (end) end.textContent = shown;
            if (bar && total) bar.style.width = Math.floor((shown * 100) / total) + '%';
            var nextMore = next.querySelector('[data-dpcl-more]');
            if (nextMore) {
              more.setAttribute('href', nextMore.getAttribute('href'));
              more.classList.remove('is-loading');
            } else {
              more.remove();
            }
            document.dispatchEvent(new CustomEvent('dermapura:cards-added', { detail: { root: grid } }));
          })
          .catch(function () { window.location.href = more.getAttribute('href'); });
      });
    }
  }

  function run() { document.querySelectorAll('[data-dpcl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
